import { reactive } from 'vue'
import { CatchedError } from '@/core/classes/CatchedError.class'
import { CatchedErrorStateT, CatchedErrorHandlerT } from '@/core/types/error.types'

export default function () {
    const error_state: CatchedErrorStateT = reactive({
        message: undefined as string | undefined,
        status: undefined as number | undefined,
        url: undefined as string | undefined,
        is_cancel: undefined as boolean | undefined,
    })

    const catchError: CatchedErrorHandlerT = (error: any): void => {
        if (error instanceof CatchedError) {
            error_state.message = error.message
            error_state.status = error.status
            error_state.url = error.url
            error_state.is_cancel = error.is_cancel

            if (!error_state.is_cancel) error.log()
        }
    }

    return { error_state, catchError }
}
